import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FacetAndFacadeCounter from 'src/components/DesignSidebar/FacetAndFacadeCounter';

export const Container = styled.div`
  position: relative;
  margin-top: 12px;
  border-radius: 2px;
  height: 30px;
  padding-left: 12px;
  line-height: 28px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.variationGray};
`;

export const DeselectButton = styled.div`
  position: absolute;
  display: inline-block;
  top: 0;
  right: 0;
  height: 100%;
  border-radius: 0 2px 2px 0;
  padding: 0 10px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.lightGrayText};

  &:hover {
    background-color: ${({ theme }) => theme.colors.darkerGray2};
  }
`;

export default class SelectedElementCount extends PureComponent {
  static propTypes = {
    styles: PropTypes.array.isRequired,
    handleClick: PropTypes.func.isRequired,
  };

  render() {
    const { styles, handleClick } = this.props;

    return (
      <Container data-selenium="selectedElementCount">
        <FacetAndFacadeCounter styles={styles} />
        <DeselectButton data-selenium="deselectAllButton" onClick={handleClick}>
          Deselect All
        </DeselectButton>
      </Container>
    );
  }
}
